import { availableLocales } from '@/constants/locale';

const checkAreaCodeExist = (welcomeLocale) => {
  const isExist = Object.keys(availableLocales).includes(welcomeLocale);
  return isExist;
};

export default checkAreaCodeExist;
